 <template>

  <v-dialog v-model="cartDialog" hide-overlay scrollable persistent>
    <v-card class="dialog-safe">
      <!-- Botón de cerrar -->

      <v-card-title class="headline text-white" style="
          padding: 16px;
          background-color: #ee8625;
          background-image: url('https://mvexpress.mx/images/logosapp/logomv1.png');
          background-size: 160px auto; /* Ajusta tamaño del logo */
          background-position: left center; /* Logo anclado a la izquierda */
          background-repeat: no-repeat;
          display: flex;
          justify-content: space-between; /* 🔹 Logo izquierda / Botón derecha */
          align-items: center;
        ">
        <!-- Contenedor vacío solo para que el botón quede a la derecha -->
        <div style="width: 140px"></div>

        <!-- Botón de cerrar a la derecha -->
        <v-btn @click="$emit('update:modelValue', false)" color="red" class="text-white p-2" rounded>
          <v-icon color="white">mdi-close</v-icon>
        </v-btn>
      </v-card-title>

      <v-card-text>
        <!-- Alerta si el carrito está vacío -->
        <v-alert v-if="cart.length === 0" color="#0e4582" prominent border="start" elevation="1">
          <div class="d-flex align-center">
            <img
              src="https://cdn.shopify.com/s/files/1/1061/1924/products/Emoji_Icon_-_Sad_Emoji_grande.png?v=1571606093"
              alt="Sad emoji" style="width: 40px; height: 40px; margin-right: 12px" />
            <div>
              <strong>¡Tu carrito está vacío!</strong> Agrega productos para comenzar tu
              compra
            </div>
          </div>
        </v-alert>

        <!-- Código de descuento con Tailwind CSS 
<div class="mb-4 flex flex-col md:flex-row gap-3">
  <div class="flex-1">
    <label for="discountCode" class="block text-sm font-medium text-gray-700 mb-1">
      Código de descuento
    </label>
    <input
      id="discountCode"
      v-model="discountCode"
      type="text"
      placeholder="Introduce tu código de descuento"
      class="w-full px-4 py-2 border border-gray-300 rounded-lg shadow-sm focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-blue-500"
    />
  </div>
  <div class="md:w-1/3 flex items-end">
    <button
      @click="applyDiscount"
      class="w-full bg-blue-600 hover:bg-blue-700 text-white font-semibold py-2 px-4 rounded-lg shadow-md transition duration-150"
    >
      Aplicar
    </button>
  </div>
</div>
-->

        <!-- Lista de productos -->

 <div v-if="cart.length > 0">
  <v-container class="pa-2">
    <v-row v-for="(item, index) in cart" :key="item.id || item.sku || index" 
           class="mb-2 position-relative overflow-hidden">
      
      <!-- Fondo de borrado (Swipe) -->
      <div class="delete-background d-flex align-center justify-end pr-6 rounded-lg"
           :style="{
             position: 'absolute', top: 0, bottom: 0, right: 0, left: 0, zIndex: 0,
             backgroundColor: isSwipeThresholdMet(item, index) ? '#4CAF50' : '#FF5252',
             transition: 'background-color 0.2s ease'
           }"
           @click="handleRemove(item)">
        <v-icon color="white" size="32" :style="{ transform: isSwipeThresholdMet(item, index) ? 'scale(1.2)' : 'scale(1)', transition: 'transform 0.2s' }">mdi-delete</v-icon>
      </div>

      <!-- Contenido (Card) -->
      <div class="w-100"
           style="z-index: 1; position: relative; touch-action: pan-y; will-change: transform;"
           @touchstart="onTouchStart($event, item, index)"
           @touchmove="onTouchMove($event, item, index)"
           @touchend="onTouchEnd($event, item, index)"
           :style="getSwipeStyle(item, index)">
      
      <v-card
  color="white"
  class="w-100 pa-2" 
  :class="{ 'gift-card-active': item.isGift }"
  variant="flat"
  border
  rounded="lg"
>
        <v-row no-gutters align="center">
          <v-col cols="3" class="d-flex justify-center align-center">
          <div class="product-image-container">
            <v-img 
              :src="item.foto" 
              alt="Imagen del producto" 
              contain 
              class="rounded-lg"
            >
              <template v-slot:placeholder>
                <v-row class="fill-height ma-0" align="center" justify="center">
                  <v-progress-circular indeterminate color="grey-lighten-2" size="20" />
                </v-row>
              </template>
            </v-img>
          </div>
        </v-col>
        <v-col cols="9" class="ps-3 d-flex flex-column justify-center">
  <div class="d-flex justify-space-between align-start">
    <div class="flex-grow-1">
      <h4 class="product-title-cart mb-1">
        <v-chip v-if="item.isGift" color="yellow" variant="flat" size="x-small" class="mr-1 font-weight-bold">
          🎁 REGALO
        </v-chip>
        {{ item.nombre }}
      </h4>
      <div class="text-caption text-grey-darken-1">SKU: {{ item.sku }}</div>
    </div>
    
    <div class="d-flex flex-column align-end ms-2">
      <v-chip v-if="item.id_promocion && item.promo_price" 
              color="red" size="x-small" variant="flat" class="font-weight-bold">
        -{{ item.promo_price }}%
      </v-chip>
    </div>
  </div>

  <div class="d-flex align-end justify-space-between mt-1">
    <div>
      <template v-if="item.id_promocion && item.promo_price > 0">
        <div class="text-caption text-grey text-decoration-line-through" style="line-height: 1">
          ${{ parseFloat(item.price / (1 - item.promo_price / 100)).toFixed(2) }}
        </div>
        <div class="text-body-1 font-weight-black text-green-darken-1">
          ${{ parseFloat(item.price).toFixed(2) }}
        </div>
      </template>
      <template v-else>
        <div class="text-body-1 font-weight-black text-blue-darken-3">
          ${{ parseFloat(item.price).toFixed(2) }}
        </div>
      </template>
    </div>

    <div class="d-flex align-center bg-grey-lighten-4 rounded-pill pa-1">
      <v-btn v-if="!item.isGift" icon size="32" variant="flat" 
             :color="item.quantity <= 1 ? 'red' : 'orange-darken-1'" 
             class="elevation-1"
             @click="item.quantity <= 1 ? toggleDeleteSwipe(item, index) : decreaseQuantity(item)">
        <v-icon size="18" color="white">{{ item.quantity <= 1 ? 'mdi-delete' : 'mdi-minus' }}</v-icon>
      </v-btn>
      
      <span class="mx-3 font-weight-bold text-body-2"> {{ item.quantity }} {{ item.pround }}</span>

      <v-btn v-if="!item.isGift" icon size="32" variant="flat" color="blue-darken-4" class="elevation-1"
             @click="increaseQuantity(item)"
             :disabled="item.isGift || (item.id_promocion && item.quantity >= 5)">
        <v-icon size="18" color="white">mdi-plus</v-icon>
      </v-btn>
    </div>
  </div>
</v-col>
        

        </v-row>
      </v-card>
      </div>
    </v-row>

    
    <v-sheet color="transparent" class="px-4 mt-6 mb-safe">
  <v-btn
    :disabled="loading"
    :loading="loading"
    @click="checkout"
    block
    color="green-darken-3"
    variant="flat"
    height="auto"
    class="text-none py-4 rounded-xl btn-checkout-responsive"
  >
    <div class="d-flex flex-column align-center w-100">
      <span class="text-subtitle-2 opacity-90 font-weight-medium">
        Finalizar pedido
      </span>
      <span class="text-h6 font-weight-bold">
        ${{ Number(calculateTotal()).toLocaleString('es-MX', { minimumFractionDigits: 2, maximumFractionDigits: 2 }) }} MXN
      </span>
    </div>
  </v-btn>
</v-sheet>


      </v-container>
    </div>
        <!-- Vaciar carrito -->

        <v-row class="mt-6 mb-3">
          <v-btn @click="confirmClear = true" class="ma-2" color="red" variant="tonal" style="text-transform: none">
            <v-icon icon="mdi-delete" color="red" start></v-icon>
            Vaciar todo el carrito ({{ totalCajas }})
          </v-btn>
        </v-row>

        <!-- 🔥 Diálogo de confirmación -->
        <v-dialog v-model="confirmClear" max-width="400">
          <v-card>
            <v-card-title class="text-h6">Confirmar acción</v-card-title>

            <v-card-text class="text-center pa-4">
              <v-icon icon="mdi-alert-circle-outline" color="orange-darken-1" size="50" class="mb-3"></v-icon>
              <div class="text-body-1 mb-3">
                ¿Estás seguro de que deseas vaciar todo el carrito?
              </div>
              <div class="bg-red-lighten-5 text-red-darken-2 font-weight-bold pa-3 rounded-lg" style="border: 1px solid #ffcdd2;">
                ⚠️ Se eliminarán todos los productos.
              </div>
            </v-card-text>

            <v-card-actions>
              <v-spacer></v-spacer>

              <v-btn variant="text" @click="confirmClear = false">
                Cancelar
              </v-btn>

              <v-btn color="red" variant="flat" @click="confirmClearAndClearCart">
                Sí, vaciar
              </v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>

        <!-- 🔥 Diálogo de confirmación para Combos -->
        <v-dialog v-model="confirmRemoveCombo" max-width="400" persistent>
          <v-card>
            <v-card-title class="text-h6">Eliminar regalo</v-card-title>

            <v-card-text>
              ¿Estás seguro de que deseas eliminar este regalo?
            </v-card-text>

            <v-card-actions>
              <v-spacer></v-spacer>

              <v-btn variant="text" @click="cancelDeleteCombo">
                Cancelar
              </v-btn>

              <v-btn color="red" variant="flat" @click="confirmDeleteCombo">
                Eliminar
              </v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>

        <!-- 🔥 Diálogo de confirmación para Promociones -->
        <v-dialog v-model="confirmRemovePromo" max-width="400" persistent>
          <v-card>
            <v-card-title class="text-h6">Eliminar producto en promoción</v-card-title>

            <v-card-text>
              Este producto tiene una promoción. Si lo eliminas, perderás el descuento. ¿Estás seguro?
            </v-card-text>

            <v-card-actions>
              <v-spacer></v-spacer>

              <v-btn variant="text" @click="cancelDeletePromo">
                Cancelar
              </v-btn>

              <v-btn color="red" variant="flat" @click="confirmDeletePromo">
                Eliminar
              </v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>

        <!-- Productos sugeridos -->
        <div v-if="suggestedItems.length > 0" class="mt-4">
          <v-card-subtitle class="text-center font-weight-bold text-black">
            Otros clientes también compraron
          </v-card-subtitle>

          <v-row class="mt-2">
            <v-col v-for="product in suggestedItems" :key="product.id" cols="6" sm="6" md="4" lg="3"
              class="flex flex-col items-center relative" style="overflow: visible;">
              <v-img :src="product.foto" width="80" height="80" alt="Imagen del producto" class="rounded" contain></v-img>

              <div class="text-caption font-weight-medium text-gray-600">
                {{ product.nombre }}
              </div>
              <!-- Precio -->
              <template v-if="product.id_promocion && product.promo_price > 0">
                <!-- Precio original rayado -->
                <div class="text-gray-500 line-through font-semibold">
                  ${{ product.price }}
                </div>

                <!-- Precio con descuento -->
                <div class="text-base sm:text-lg md:text-xl font-semibold text-red">
                  ${{
                    (product.price - (product.price * product.promo_price) / 100).toFixed(2)
                  }}
                </div>
              </template>
              <template v-else>
                <div class="text-base sm:text-lg md:text-xl font-semibold text-blue-700">
                  ${{ product.price }}
                </div>
              </template>
              <div v-if="product.id_promocion && product.promo_price > 0"
                class="mt-1 inline-block px-2 py-1 bg-green-500 text-white text-xs font-bold rounded-full">
                Descuento {{ product.promo_price }}%
              </div>
              
              <!-- Controles de cantidad o botón agregar -->
              <div v-if="getProductQuantity(product) > 0" class="d-flex align-center bg-white rounded-pill elevation-2 px-1"
                   style="position: absolute; top: -10px; right: -10px; z-index: 10;">
                <v-btn icon size="24" color="red" variant="flat" class="ma-0" 
                       @click="getProductQuantity(product) === 1 ? handleRemove(product) : decreaseQuantity(product)">
                  <v-icon color="white" size="14">{{ getProductQuantity(product) === 1 ? 'mdi-delete' : 'mdi-minus' }}</v-icon>
                </v-btn>
                <span class="mx-2 font-weight-bold text-caption text-black">{{ getProductQuantity(product) }}</span>
                <v-btn icon size="24" color="blue-darken-4" variant="flat" class="ma-0" @click="increaseQuantity(product)">
                  <v-icon color="white" size="14">mdi-plus</v-icon>
                </v-btn>
              </div>

              <v-btn v-else @click="addToCart(product)" icon size="36" color="white" variant="flat" class="elevation-2"
                style="position: absolute; top: -10px; right: -10px; z-index: 10;">
                <v-icon color="blue-darken-4" size="24">mdi-plus-circle</v-icon>
              </v-btn>
            </v-col>
          </v-row>
        </div>
      </v-card-text>

      <!-- Subtotal y acción -->
      <v-card-actions class="flex flex-col">



      </v-card-actions>
    </v-card>
  </v-dialog>

</template>

<style scoped>

.btn-checkout-responsive {
  /* Permite que el botón crezca verticalmente según el texto */
  min-height: 68px !important; 
  white-space: normal !important; /* Crucial: permite saltos de línea */
  word-break: break-word;
}

/* Ajuste de línea para que no se vean muy separados los textos */
.btn-checkout-responsive .d-flex {
  line-height: 1.2;
}

/* Safe area para evitar que en iPhone quede debajo de la barra de inicio */
.mb-safe {
  margin-bottom: calc(20px + env(safe-area-inset-bottom)) !important;
}

/* En pantallas muy pequeñas (iPhone SE), reducimos un poco la fuente */
@media (max-width: 350px) {
  .text-h6 {
    font-size: 1rem !important;
  }
}
/* Lógica para que el botón crezca con el texto (Zoom/Accesibilidad) */
.button-zoom-fix {
  height: auto !important; 
  min-height: 54px; /* Altura más compacta y responsiva */
  padding-top: 10px !important;
  padding-bottom: 10px !important;
}

/* Manejo del Safe Area para iPhone */
.mb-safe {
  margin-bottom: calc(16px + env(safe-area-inset-bottom));
}

/* Asegura que el texto del precio no se rompa */
.text-no-wrap {
  white-space: normal; /* Permitir wrap si es necesario en pantallas muy pequeñas con texto gigante */
}
.gift-card-active {
  border: 1px solid #e1bee7 !important; /* Borde morado muy suave */
  background: linear-gradient(135deg, #ffffff 70%, #f3e5f5 100%) !important; /* Fondo blanco con toque morado al final */
  box-shadow: 0 4px 12px rgba(156, 39, 176, 0.15) !important;
  position: relative;
  overflow: hidden;
}

/* Barra lateral decorativa */
.gift-card-active::before {
  content: '';
  position: absolute;
  left: 0;
  top: 0;
  bottom: 0;
  width: 5px;
  background: #8e24aa; /* Morado fuerte */
}

  .product-title-cart {
  font-size: 0.85rem !important; /* Tamaño más pequeño y legible */
  line-height: 1.1rem;
  font-weight: 600;
  color: #2c3e50;
  display: -webkit-box;
  -webkit-line-clamp: 2; /* Muestra máximo 2 líneas */
  -webkit-box-orient: vertical;
  overflow: hidden;
  text-overflow: ellipsis;
}

/* Ajuste opcional para el precio si sigue pareciendo grande */
.text-body-1 {
  font-size: 1rem !important; 
}
.product-image-container {
  width: 60px;      /* Ancho fijo */
  height: 60px;     /* Alto fijo */
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: #ffffff;
  border: 1px solid #f5f5f5; /* Un borde muy sutil */
  border-radius: 8px;
  overflow: hidden;
  padding: 4px;     /* Espacio interno para que el producto no toque los bordes */
}

/* Forzamos que la imagen respete el contenedor sin deformarse */
.product-image-container .v-img__img {
  object-fit: contain !important; 
}
  /* Ajuste para que el texto largo no rompa el diseño */
.line-height-tight {
  line-height: 1.2 !important;
}

/* Contenedor del swipe */

/* Efecto de pulsación en el botón de pagar */
.wave-button {
  transition: transform 0.2s;
}
.wave-button:active {
  transform: scale(0.98);
}
.product-name {
  word-break: break-word;
  /* rompe palabras largas */
  overflow-wrap: anywhere;
  /* fuerza que se divida si no cabe */
  white-space: normal;
  /* asegura que no se quede en una sola línea */
}

.product-info p {
  word-break: break-word;
  overflow-wrap: anywhere;
}




.wave-button {
  position: relative;
  /* ya lo tienes */
  overflow: visible;
  /* 🔹 permite que ::after sobresalga */
}

.wave-button::after {
  content: "";
  position: absolute;
  left: 50%;
  top: 50%;
  width: 0;
  height: 0;
  background: rgba(255, 255, 255, 0.3);
  border-radius: 50%;
  transform: translate(-50%, -50%);
  transition: width 0.6s ease, height 0.6s ease, opacity 0.6s ease;
  pointer-events: none;
}

.dialog-safe {
  height: calc(100vh - env(safe-area-inset-top) - env(safe-area-inset-bottom));
  margin-top: env(safe-area-inset-top);
  margin-bottom: env(safe-area-inset-bottom);
  border-radius: 0 !important;
}

.wave-button:active::after {
  width: 300px;
  height: 300px;
  opacity: 0;
}

.dialog-safe {
  overscroll-behavior: contain; /* Evita recarga al deslizar en el carrito */
}
</style>



<script setup>
import { inject, computed, ref, onMounted, watch, reactive } from "vue";
import { useRouter } from "vue-router";
import api from "@/services/api";

// eslint-disable-next-line no-undef
const props = defineProps(['modelValue']);
// eslint-disable-next-line no-undef
const emit = defineEmits(['update:modelValue']);

const cartDialog = computed({
  get: () => props.modelValue,
  set: (val) => emit('update:modelValue', val)
});

const confirmClear = ref(false);
const confirmRemoveCombo = ref(false);
const itemComboToRemove = ref(null);
const confirmRemovePromo = ref(false);
const itemPromoToRemove = ref(null);

// Inyectar el store del carrito
const cartStore = inject("cartStore");
if (!cartStore) {
  throw new Error("cartStore no fue proporcionado");
}

// Computado del carrito con valor por defecto
const cart = computed(() => cartStore.state?.cart ?? []);

// Computado para el total de cajas
const totalCajas = computed(() => {
  return cart.value.reduce((total, item) => total + item.quantity, 0);
});

// Productos sugeridos
const suggestedItems = ref([]);

// Manejar eliminación de productos
const handleRemove = (item) => {
  if (item.isGift) {
    // Si es regalo, pedir confirmación antes de borrar
    itemComboToRemove.value = item;
    confirmRemoveCombo.value = true;
  } else if (item.id_promocion) {
    // Si es producto con promoción, también preguntar
    itemPromoToRemove.value = item;
    confirmRemovePromo.value = true;
  } else {
    // Si es producto normal, eliminar directo sin preguntar
    const index = cart.value.findIndex((p) => p.sku === item.sku && p.id === item.id);
    if (index !== -1) {
      cartStore.removeFromCart(index);
    }
  }
};

// Obtener productos sugeridos desde el backend
// Obtener productos sugeridos desde el backend
const fetchSuggestedProducts = async () => {
  try {

    const response = await api.get(
      "https://mvexpress.mx/api/productos/suggested-products");

    if (Array.isArray(response.data)) {
      suggestedItems.value = response.data;
    }

  } catch (err) {
    console.error("Error al obtener productos sugeridos:", err);
  }
};

// Verificar si el carrito se está actualizando correctamente
// Verificar si el carrito se está actualizando correctamente
watch(cart, (newCart) => {
  console.log("Contenido actualizado del carrito:", newCart);
  // Reiniciar swipes al cambiar el carrito para evitar que nuevos elementos aparezcan abiertos
  for (const key in swipeState) {
    delete swipeState[key];
  }
}, { deep: true });

// Al montar el componente
onMounted(() => {
  fetchSuggestedProducts();
});

const router = useRouter();

// Agregar producto al carrito
const addToCart = (product) => {
  const currentQty = getProductQuantity(product);

  // 🔹 Limite para productos en promoción
  if (product.id_promocion && currentQty >= 1) {
    alert("Solo puedes agregar 1 unidad de este producto en promoción.");
    return;
  }

 

  cartStore.addToCart(product);
};

// Aumentar cantidad
const increaseQuantity = async (item) => {
  console.log("🔹 item.isGift:", item.isGift); // muestra true/false en consola
  // alert(`isGift: ${item.isGift ? "Sí" : "No"}`); // alerta

  if (item.isGift) return; // evita aumentar regalos

  // Lógica para Media Caja (PZA) - Aumentar en bloque
  if (item.pround === 'PZA' && item.PRODUC_PZAMINVTA) {
    const pieces = parseInt(item.PRODUC_PZAMINVTA) || 1;
    for (let i = 0; i < pieces; i++) {
      cartStore.increaseQuantity(item);
    }
    return;
  }

  cartStore.increaseQuantity(item);
};


const decreaseQuantity = (item) => {
  if (item.pround === 'PZA' && item.PRODUC_PZAMINVTA) {
    const pieces = parseInt(item.PRODUC_PZAMINVTA) || 1;
    for (let i = 0; i < pieces; i++) {
      cartStore.decreaseQuantity(item);
    }
    return;
  }
  cartStore.decreaseQuantity(item);
};

const getProductQuantity = (product) => {
  const item = cart.value.find(
    (p) => (p.id || p.producto_id) === (product.id || product.producto_id)
  );
  return item ? item.quantity || 0 : 0;
};

// Eliminar del carrito


//
// Calcular total del carrito
// LISTADO / HOME
const calculateTotal = () => {
  return Number(
    cart.value.reduce((acc, item) => {
      const price = Number(item.price);
      const qty = Number(item.quantity ?? 1);
      return acc + price * qty;
    }, 0).toFixed(2)
  );
};




const confirmClearAndClearCart = () => {
  cartStore.clearCart();
  confirmClear.value = false;
};

// Ir al checkout
const checkout = () => {
  const total = parseFloat(calculateTotal());

  // Guardar todo lo necesario
  localStorage.setItem("checkoutTotal", total);
  localStorage.setItem("checkoutCart", JSON.stringify(cart.value));
  localStorage.setItem("checkoutCajas", totalCajas.value);

  cartDialog.value = false;
  router.push({ path: "/metodo-pago" });
};

const confirmDeleteCombo = () => {
  if (itemComboToRemove.value) {
    // Eliminar solo el ítem seleccionado (el regalo)
    const index = cart.value.indexOf(itemComboToRemove.value);
    if (index !== -1) {
      cartStore.removeFromCart(index);
    }
    confirmRemoveCombo.value = false;
    itemComboToRemove.value = null;
  }
};

const cancelDeleteCombo = () => {
  confirmRemoveCombo.value = false;
  itemComboToRemove.value = null;
};

const confirmDeletePromo = () => {
  if (itemPromoToRemove.value) {
    const index = cart.value.findIndex((p) => p.sku === itemPromoToRemove.value.sku && p.id === itemPromoToRemove.value.id);
    if (index !== -1) {
      cartStore.removeFromCart(index);
    }
    confirmRemovePromo.value = false;
    itemPromoToRemove.value = null;
  }
};

const cancelDeletePromo = () => {
  confirmRemovePromo.value = false;
  itemPromoToRemove.value = null;
};

// --- 🔥 Swipe to Delete Logic ---
const swipeState = reactive({});
const vibrationState = {}; // Control para vibrar solo una vez

const getSwipeKey = (item, index) => item.id || item.sku || index;

const isSwipeThresholdMet = (item, index) => {
  const key = getSwipeKey(item, index);
  return (swipeState[key]?.currentX || 0) < -200;
};

const onTouchStart = (e, item, index) => {
  const key = getSwipeKey(item, index);
  vibrationState[key] = false; // Reset vibración
  swipeState[key] = {
    startX: e.touches[0].clientX,
    startY: e.touches[0].clientY,
    currentX: swipeState[key]?.currentX || 0,
    isSwiping: true,
    startOffset: swipeState[key]?.currentX || 0
  };
};

const onTouchMove = (e, item, index) => {
  const key = getSwipeKey(item, index);
  if (!swipeState[key]?.isSwiping) return;

  const currentX = e.touches[0].clientX;
  const currentY = e.touches[0].clientY;
  const diffX = currentX - swipeState[key].startX;
  const diffY = currentY - swipeState[key].startY;

  // Si el movimiento es más vertical que horizontal, ignorar swipe
  if (Math.abs(diffY) > Math.abs(diffX)) {
    swipeState[key].isSwiping = false; // Cancelar swipe si es scroll vertical
    return;
  }

  let newX = swipeState[key].startOffset + diffX;
  if (newX > 0) newX = 0; // No permitir swipe a la derecha

  swipeState[key].currentX = newX;

  // 📳 Feedback Háptico Nativo (Vibración corta al cruzar umbral)
  if (newX < -200 && !vibrationState[key]) {
    if (navigator.vibrate) navigator.vibrate(15); // Vibración seca y corta
    vibrationState[key] = true;
  } else if (newX > -200 && vibrationState[key]) {
    vibrationState[key] = false;
  }
};

const onTouchEnd = (e, item, index) => {
  const key = getSwipeKey(item, index);
  if (!swipeState[key]) return;

  swipeState[key].isSwiping = false;

  // Si desliza lo suficiente (ej. > 200px), eliminar directamente
  if (swipeState[key].currentX < -200) {
    handleRemove(item);
  } else if (swipeState[key].currentX < -60) {
    swipeState[key].currentX = -100; // Mantener abierto
  } else {
    swipeState[key].currentX = 0; // Cerrar
  }
};

const toggleDeleteSwipe = (item, index) => {
  const key = getSwipeKey(item, index);
  if (!swipeState[key]) {
    swipeState[key] = { currentX: 0, isSwiping: false, startX: 0, startY: 0, startOffset: 0 };
  }
  
  if (swipeState[key].currentX <= -50) {
    // Si ya está abierto (botón basura activo), eliminar al hacer clic de nuevo
    handleRemove(item);
  } else {
    swipeState[key].currentX = -100; // Abrir deslizando a la izquierda
  }
};

const getSwipeStyle = (item, index) => {
  const key = getSwipeKey(item, index);
  const x = swipeState[key]?.currentX || 0;
  const isSwiping = swipeState[key]?.isSwiping || false;
  return {
    transform: `translateX(${x}px)`,
    transition: isSwiping ? 'none' : 'transform 0.5s cubic-bezier(0.2, 0.8, 0.2, 1)' // Curva elástica estilo iOS
  };
};
</script>
